"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateItemListReducer = exports.createItemListReducer = exports.fetchItemListReducer = exports.updateItemListSlice = exports.createItemListSlice = exports.fetchItemListSlice = exports.updateInitialState = exports.createInitialState = exports.fetchInitialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const itemListAction_1 = require("./itemListAction");
exports.fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.createInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
exports.fetchItemListSlice = (0, toolkit_1.createSlice)({
    name: "itemList/fetch",
    initialState: exports.fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(itemListAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(itemListAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(itemListAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createItemListSlice = (0, toolkit_1.createSlice)({
    name: "itemList/create",
    initialState: exports.createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(itemListAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(itemListAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(itemListAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateItemListSlice = (0, toolkit_1.createSlice)({
    name: "itemList/update",
    initialState: exports.updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(itemListAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(itemListAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(itemListAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchItemListReducer = exports.fetchItemListSlice.reducer;
exports.createItemListReducer = exports.createItemListSlice.reducer;
exports.updateItemListReducer = exports.updateItemListSlice.reducer;
